// extracted by mini-css-extract-plugin
module.exports = {"bm-portal":"bm-portal","bm-soccer-portal-modal":"bm-soccer-portal-modal","modal":"modal"};